import React from 'react';
import PropTypes from 'prop-types';
//import { Button } from 'v1/components/shared';

import { PublicLinkStatus } from 'v1/components/shared/general/PublicLinkStatus/PublicLinkStatus';
import classnames from 'classnames';
import ToggleImport from 'react-toggle';
import './PublishingActionBox.scss';

// CJS package: Vite/Node may surface `{ default: Toggle }` instead of the component
const Toggle = ToggleImport.default ?? ToggleImport;

const PublishingActionBox = props => {
  const renderURL = activeState => {
    const { url, destination, isPublished, publicPath } = props;
    return (
      <div className="PublishingActionBox-publishedLink">
        <PublicLinkStatus
          className="stack-XS"
          url={url}
          publicPath={publicPath}
          destination={destination}
          status={{
            active: isPublished
          }}
        />
        {/* TODO: Remove: ? */}
        {/* <Button
									onClick={activeState.action}
									className="PublishingActionBox-unpublishButton"
								>
									Unpublish
								</Button> */}
      </div>
    );
  };

  // TODO: Remove: ?
  const renderButton = activeState => {
    //const { updating } = props;
    return;
    /*return (
      <Button
        className="btn btn-primary btn-fill"
        onClick={activeState.action}
        isLoading={updating}
      >
        Publish
      </Button>
    );*/
  };

  const { isPublished, publishedState, unpublishedState } = props;
  const activeState = isPublished ? publishedState : unpublishedState;

  return (
    <div className="PublishingActionBox">
      <div className="PublishingActionBox-header">
        <span
          className={classnames({ published: isPublished }, [
            'PublishingActionBox-icon'
          ])}
        >
          <img
            className="icon"
            width="15px"
            alt=""
            src={
              isPublished
                ? '/images/icon_tick_white.svg'
                : '/images/icon_draft.svg'
            }
          />
        </span>
        <div className="PublishingActionBox-header-toggle">
          <span className="PublishingActionBox-header-toggle-label">
            Published
          </span>
          <span className="PublishingActionBox-header-toggle-btn">
            <Toggle
              defaultChecked={isPublished}
              onChange={e => {
                //const checked = e.target.checked;
                activeState.action();
              }}
              icons={false}
            />
          </span>
        </div>
      </div>
      <h3>{activeState.title}</h3>
      <p>{activeState.description}</p>
      {isPublished ? renderURL(activeState) : renderButton(activeState)}
    </div>
  );
};

const activeStateShape = PropTypes.shape({
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.func
});

PublishingActionBox.propTypes = {
  url: PropTypes.string, // TODO: as passed to PublicLinkStatus
  publicPath: PropTypes.string,
  destination: PropTypes.string, // TODO: as passed to PublicLinkStatus
  isPublished: PropTypes.bool,
  updating: PropTypes.bool,
  publishedState: activeStateShape, // TODO: if isPublished then publishedState is required
  unpublishedState: activeStateShape // TODO: if !isPublished then unpublishedState is required
};

export default PublishingActionBox;
